<template>
  <v-form ref="formRef" @submit.prevent="handleSubmit">
    <div class="card">
      <div class="card-body">
        <h3 class="fz-20 fw-500">Surat Pernyataan</h3>
        <!-- <p class="text-gray-4">Pengajuan Keberatan Pajak Kendaraan Bermotor</p> -->
        <br />
        <p class="fw-500">Yang bertandatangan dibawah ini</p>
        <div class="mb-3">
          <label for="" class="mb-3">Nama</label>
          <v-text-field
            placeholder="Nama Lengkap"
            v-model="laporjualname"
            dense
            filled
            solo
            class="input-primary"
            required
            :rules="[
              (value) => {
                return genericRequiredRule(value, 'Nama');
              },
            ]"
          ></v-text-field>
        </div>
        <div class="mb-3">
          <label for="" class="mb-3">Alamat</label>
          <v-text-field
            placeholder="Alamat Lengkap"
            v-model="laporjualaddress"
            dense
            filled
            solo
            class="input-primary"
            required
            :rules="[
              (value) => {
                return genericRequiredRule(value, 'Alamat');
              },
            ]"
          ></v-text-field>
        </div>
        <div class="mb-3">
          <label for="" class="mb-0">Bertindak Selaku</label>
          <v-radio-group
            class="radio-primary"
            v-model="tindak_selaku"
            row
            :rules="[
              (value) => {
                return genericRequiredRule(value, 'Bertindak Selaku');
              },
            ]"
          >
            <v-radio
              v-for="(item, index) in listBertindakSelaku"
              :key="index"
              :label="item"
              :value="item"
            ></v-radio>
          </v-radio-group>
        </div>
        <div class="card">
          <div class="card-body">
            <atom-table
              label="Nomor Registrasi (Nopol)"
              :value="infoKendaraan.nopol"
            />
            <atom-table label="Jenis Kendaraan" :value="form.jeniskendaraan" />
            <atom-table
              label="Merk/Type"
              :value="`${infoKendaraan.merk}/${infoKendaraan.type}`"
            />
            <atom-table label="Nomor Handphone" :value="form.no_hp" />
            <atom-table label="No KK/KTP" :value="form.nik" />
          </div>
        </div>
        <br />
        <p class="text-gray-4">
          Menyatakan dengan sebenar - benarnya atas kendaraan yang dimaksud
          diatas :
        </p>
        <div class="mb-3">
          <v-radio-group
            class="radio-primary"
            v-model="alasan"
            :rules="[
              (value) => {
                return genericRequiredRule(value, 'Alasan');
              },
            ]"
          >
            <v-radio
              v-for="(item, index) in listAlasan"
              :key="index"
              :label="item"
              :value="item"
            ></v-radio>
          </v-radio-group>
        </div>
        <div class="d-flex justify-content-end">
          <div class="">
            <p class="fw-700 text-right">Batam, {{ dateNow }}</p>
            <div class="border" style="max-width: 300px; max-height: 150px">
              <VPerfectSignature
                :stroke-options="strokeOptions"
                ref="signaturePad"
              />
            </div>
            <p
              class="fw-500 text-right text-muted"
              style="cursor: pointer"
              @click="handleResetSignature"
            >
              Reset
            </p>
          </div>
        </div>

        <v-checkbox
          label="Saya menyetujui bahwa data yang telah dimasukan adalah benar dan dapat dipertanggungjawabkan"
          v-model="isAgree"
        ></v-checkbox>
      </div>
    </div>
    <br />
    <div class="row justify-content-end">
      <div class="col-12 col-md-5 col-lg-2 mb-3 mb-md-0">
        <v-btn @click="handleKembali" class="btn btn-kembali w-100">
          <box-icon name="arrow-back" color="#67747E" class="mr-2"></box-icon>
          Kembali
        </v-btn>
      </div>
      <div class="col-12 col-md-5 col-lg-3">
        <v-btn type="submit" class="btn btn-primary w-100" :disabled="!isAgree">
          Konfirmasi & Buat Laporan
        </v-btn>
      </div>
    </div>
  </v-form>
</template>

<script>
import { FieldRequired } from "@/mixins/ValidationRules";
import VPerfectSignature from "v-perfect-signature";
import moment from "moment";

export default {
  name: "KonfirmasiPelaporan",
  mixins: [FieldRequired],
  components: {
    AtomTable: () => import("@/components/atoms/AtomTable"),
    VPerfectSignature,
  },
  data() {
    return {
      listBertindakSelaku: ["Wajib Pajak", "Kuasa dari Wajib Pajak"],
      listAlasan: [
        "Kendaraan sudah dijual",
        "Kendaraan rusak",
        "Kendaraan hilang",
        "Dan lain-lain",
      ],
      dateNow: moment().format("ll"),
      strokeOptions: {
        size: 7,
      },
      isAgree: false,
    };
  },
  computed: {
    form() {
      return this.$store.state.main.form;
    },
    infoKendaraan() {
      return this.$store.state.main.infoKendaraan;
    },
    laporjualname: {
      get() {
        return this.$store.state.main.form.laporjualname;
      },
      set(value) {
        this.$store.commit("SET_FORM_MAIN", {
          key: "laporjualname",
          value: value,
        });
      },
    },
    laporjualaddress: {
      get() {
        return this.$store.state.main.form.laporjualaddress;
      },
      set(value) {
        this.$store.commit("SET_FORM_MAIN", {
          key: "laporjualaddress",
          value: value,
        });
      },
    },
    tindak_selaku: {
      get() {
        return this.$store.state.main.form.tindak_selaku;
      },
      set(value) {
        this.$store.commit("SET_FORM_MAIN", {
          key: "tindak_selaku",
          value: value,
        });
      },
    },
    alasan: {
      get() {
        return this.$store.state.main.form.alasan;
      },
      set(value) {
        this.$store.commit("SET_FORM_MAIN", {
          key: "alasan",
          value: value,
        });
      },
    },
    fileDigitalSign: {
      get() {
        return this.$store.state.main.form.fileDigitalSign;
      },
      set(value) {
        this.$store.commit("SET_FORM_MAIN", {
          key: "fileDigitalSign",
          value: value,
        });
      },
    },
  },
  methods: {
    handleKembali() {
      this.$store.commit("SET_STEPPER_ACTIVE", 2);
    },
    handleSubmit() {
      if (this.$refs.formRef.validate()) {
        this.fileDigitalSign = this.$refs.signaturePad
          .toDataURL()
          .split(",")[1];
        this.$store.dispatch("AddVehicle");
        this.isAgree = false;
      }
    },
    handleResetSignature() {
      this.$refs.signaturePad.clear();
    },
    // dataURLtoFile(dataurl, filename) {
    //   var arr = dataurl.split(","),
    //     mime = arr[0].match(/:(.*?);/)[1],
    //     bstr = atob(arr[1]),
    //     n = bstr.length,
    //     u8arr = new Uint8Array(n);

    //   while (n--) {
    //     u8arr[n] = bstr.charCodeAt(n);
    //   }

    //   return new File([u8arr], filename, { type: mime });
    // },
  },
};
</script>
